<template>
  <div class="limit">
      <div class="limit-dialog">
          <div class="limit-close" @click="handleClose"></div>
          <div class="limit-title">
            <div class="limit-title-stop"></div>
            <h1 class="limit-title-des">下载额度已满</h1>
          </div>
          <div class="limit-des">
            您今日下载次数 <span style="color:#4A96E8;font-weight: 600; ">已达上限(10次)</span> ，请明天再来下载吧！
          </div>
          <button class="limit-service" @click="handleClose">好的</button>
      </div>
  </div>
</template>

<script>
export default {
  name: 'LimitDialog',
  methods: {
    handleClose () {
      document.body.removeChild(this.$parent.$el)
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/styleMixins";
  .limit{
    position: fixed;
    z-index: 1000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .flex_center_mixins;
    background-color: rgba(0,0,0,.3);
    &-dialog {
      width: 400px;
      height: 244px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 8px;
      position: relative;
    }
    &-title{
      margin-top: 40px;
      .flex_center_mixins;
      font-size: 20px;
      font-weight: 500;
      line-height: 34px;
      color: #3D6BFF;
      &-stop{
        height: 20px;
        width: 20px;
        border-radius: 50%;
        position: relative;
        .flex_center_mixins;
        background-color: #3D6BFF;
        margin-right: 16px;
        &::before{
          content: '';
          position: absolute;
          display: block;
          height: 13px;
          width: 2px;
          background-color: white;
          transform: rotateZ(45deg);
        }
        &::after{
          content: '';
          position: absolute;
          display: block;
          height: 13px;
          width: 2px;
          background-color: white;
          transform: rotateZ(-45deg);
        }
      }
    }
    &-des{
      text-align: center;
      font-size: 14px;
      font-weight: bold;
      line-height: 24px;
      color: #333333;
      margin-top: 36px;
    }
    &-service{
      .clear_button_default_mixins;
      font-size: 14px;
      color: #FFFFFF;
      padding: 9px 27px;
      display: block;
      margin:  0 auto;
      background: #3D6BFF;
      border-radius: 8px;
      border-width: 0;
      margin-top: 37px;
    }
    &-close{
      position: absolute;
      right: 14px;
      top: 14px;
      height: 12px;
      width: 12px;
      cursor: pointer;
      &::before{
        content: '';
        position: absolute;
        display: block;
        height: 18px;
        width: 2px;
        background: #D3D3D3;
        transform: rotateZ(45deg);
      }
      &::after{
        content: '';
        position: absolute;
        display: block;
        height: 18px;
        width: 2px;
        background: #D3D3D3;
        transform: rotateZ(-45deg);
      }
      &:hover{
        transform: scale(1.2);
      }
    }
  }
</style>
